// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../ASSETS/BACKGROUND/NoiseBg.webp", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* MAIN NAVBAR */
.custom-navbar {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  background-position: center;
  width: 100%;
  z-index: 1000;
  padding: 0.6rem 1.2rem;
}

/* LOGO */
.navbar-logo {
  width: 350px;
  height: auto;
}

/* NAV LINKS */
.navbar-links .nav-link {
  color: #ffffff;
  margin-left: 1.2em;
  font-size: 1rem;
  font-weight: 500;
  transition: 0.25s ease;
}

/* HOVER / ACTIVE */
.navbar-links .nav-link:hover,
.navbar-links .nav-link:active {
  color: #FFE600;
}

/* TOGGLER ICON */
.navbar-toggler {
  border-color: rgba(255, 255, 255, 0.7);
}

.navbar-toggler-icon {
  background-color: #ffffff;
  border-radius: 3px;
}

/* PREVENT WRAPPING */
.navbar-links {
  flex-wrap: nowrap;
}
`, "",{"version":3,"sources":["webpack://./src/COMPONENTS/NAVBAR/index.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;EACE,yDAA6D;EAC7D,sBAAsB;EACtB,2BAA2B;EAC3B,WAAW;EACX,aAAa;EACb,sBAAsB;AACxB;;AAEA,SAAS;AACT;EACE,YAAY;EACZ,YAAY;AACd;;AAEA,cAAc;AACd;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA,mBAAmB;AACnB;;EAEE,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA,qBAAqB;AACrB;EACE,iBAAiB;AACnB","sourcesContent":["/* MAIN NAVBAR */\n.custom-navbar {\n  background-image: url(\"../../ASSETS/BACKGROUND/NoiseBg.webp\");\n  background-size: cover;\n  background-position: center;\n  width: 100%;\n  z-index: 1000;\n  padding: 0.6rem 1.2rem;\n}\n\n/* LOGO */\n.navbar-logo {\n  width: 350px;\n  height: auto;\n}\n\n/* NAV LINKS */\n.navbar-links .nav-link {\n  color: #ffffff;\n  margin-left: 1.2em;\n  font-size: 1rem;\n  font-weight: 500;\n  transition: 0.25s ease;\n}\n\n/* HOVER / ACTIVE */\n.navbar-links .nav-link:hover,\n.navbar-links .nav-link:active {\n  color: #FFE600;\n}\n\n/* TOGGLER ICON */\n.navbar-toggler {\n  border-color: rgba(255, 255, 255, 0.7);\n}\n\n.navbar-toggler-icon {\n  background-color: #ffffff;\n  border-radius: 3px;\n}\n\n/* PREVENT WRAPPING */\n.navbar-links {\n  flex-wrap: nowrap;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
